import Link from "next/link";
import { sanitizeHTML } from "@/lib/utils";

interface PlanForYourSurgeryData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  button?: {
    label?: string;
    href?: string;
  };
}

export const fields = [
  // headings
  "heading.text",
  "heading.title",

  // text
  "text.text",

  // button
  "button.label",
  "button.href",
] as const;

interface PlanForYourSurgeryProps {
  data?: PlanForYourSurgeryData;
}

export default function PlanForYourSurgery({ data }: PlanForYourSurgeryProps) {
  return (
    <section className="w-full bg-light">
      <div className="container mx-auto px-8 py-8 xl:py-20">
        <div className="w-full max-w-screen-lg mx-auto">
          {/* Heading */}
          <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-primary text-center pb-8">
            {data?.heading?.title}
          </h2>

          {/* Description */}
          <p className="text-center text-primary md:text-xl text-[1rem] font-normal md:leading-7 leading-normal font-greycliff md:tracking-tight pb-8">
            {data?.text?.text && <span className="md:text-xl text-[1rem] md:leading-7 leading-normal" dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text)} />}
          </p>

          {/* CTA Button */}
          <div className="text-center">
            {data?.button?.href && data?.button?.label && (
              <Link href={data.button.href || "#"}>
                <button className="px-12 py-5 bg-primary text-white rounded-full hover:bg-light hover:text-primary hover:shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] transition-all border border-primary">
                  <span className="text-xl font-normal font-greycliff leading-7 tracking-tight">
                    {data.button.label}
                  </span>
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
} 